"use client"

// src/modal-context.ts
import { createContext } from "@yamada-ui/utils";
var [ModalProvider, useModal] = createContext({
  name: `ModalContext`,
  errorMessage: `useModal returned is 'undefined'. Seems you forgot to wrap the components in "<Modal />" `
});
var [DialogProvider, useDialog] = createContext({
  name: `DialogContext`,
  errorMessage: `useDialog returned is 'undefined'. Seems you forgot to wrap the components in "<Dialog />" `
});
var [DrawerProvider, useDrawer] = createContext({
  name: `DrawerContext`,
  errorMessage: `useDrawer returned is 'undefined'. Seems you forgot to wrap the components in "<Drawer />" `
});

export {
  ModalProvider,
  useModal,
  DialogProvider,
  useDialog,
  DrawerProvider,
  useDrawer
};
//# sourceMappingURL=chunk-64A25YOZ.mjs.map